import { getBackendErrorMessages } from '../global-constants';

export const getQuestionAlias = (title: string) => {
	if (!title) return '';

	return title
		.toLowerCase()
		.replace(/[^\w ]+/g, '')
		.replace(/ +/g, '-');
};

export const getBackendErrorMessage = (errorCode: number) => getBackendErrorMessages()[errorCode] || 'Something went wrong';

export const removeUserTagFromText = (text: string) => {
	const regex = /\[user\sid=.*?\](.*?)(\[\/user])/;
	const cleanText = text?.replace(regex, '$1');

	return cleanText;
};
